<template>
    <div class="iodid-ionen">
        <p>
            Ergibt mit Silbernitrat einen gelben Niederschlag
            <br />
            Ag<sup>+</sup> + I<sup>-</sup> → AgI
        </p>
    </div>
</template>

<script>
export default {
    name: 'iodid-ionen',
};
</script>
